import { all, put, takeEvery } from "redux-saga/effects";
import { fetcher, getErrorMsg, handleError } from "lib/fetch";
import * as actions from "./actions";

const url = "product-types"

function* loadProductTypes(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(url, params, token);
    yield put(actions.loadProductTypes.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.loadProductTypes.failure(getErrorMsg(error)));
  }
}

function* showProductType(action) {
  try {
    const { id, token } = action.payload;
    const res = yield fetcher.get(`${url}/${id}`, token);
    yield put(actions.showProductType.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.showProductType.failure(getErrorMsg(error)));
  }
}

function* createProductType(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/create`, params, token);
    yield put(actions.createProductType.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.createProductType.failure(getErrorMsg(error)));
  }
}

function* updateProductType(action) {
  try {
    const { params, id, token } = action.payload;
    const res = yield fetcher.post(`${url}/update/${id}`, params, token);
    yield put(actions.updateProductType.success(res.data));
   
  } catch (error) {
    handleError(error);
    yield put(actions.updateProductType.failure(getErrorMsg(error)));
  }
}

function* deleteProductType(action) {
  try {
    const { id, token } = action.payload;
    yield fetcher.get(`${url}/delete/${id}`, token);
    yield put(actions.deleteProductType.success(id));
  } catch (error) {
    handleError(error);
    yield put(actions.deleteProductType.failure(getErrorMsg(error)));
  }
}

function* importProductType(action) {
  try {
    const { file, token } = action.payload;
    const formData = new FormData();
    formData.append("file_name", file.originFileObj);
    const res = yield fetcher.upload(`${url}/import`, formData, token);
    yield put(actions.importProductType.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.importProductType.failure(getErrorMsg(error)));
  }
}

function* exportProductType(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/export`, params, token);
    yield put(actions.exportProductType.success(res.data));
    fetcher.download(res.data.data);
  } catch (error) {
    handleError(error);
    yield put(actions.exportProductType.failure(getErrorMsg(error)));
  }
}

export default function* watchProductType() {
  yield all([
    takeEvery(actions.LOAD_PRODUCTTYPE.REQUEST, loadProductTypes),
    takeEvery(actions.SHOW_PRODUCTTYPE.REQUEST, showProductType),
    takeEvery(actions.CREATE_PRODUCTTYPE.REQUEST, createProductType),
    takeEvery(actions.UPDATE_PRODUCTTYPE.REQUEST, updateProductType),
    takeEvery(actions.DELETE_PRODUCTTYPE.REQUEST, deleteProductType),
    takeEvery(actions.IMPORT_PRODUCTTYPE.REQUEST, importProductType),
    takeEvery(actions.EXPORT_PRODUCTTYPE.REQUEST, exportProductType),
  ]);
}
